import {Component, Input, OnInit} from '@angular/core';
import {AnswerOption} from '../../../data/models/test/answer';
import {AnsweredOption} from '../../../data/models/result/answered-result';

@Component({
  selector: 'app-answered-options-result',
  templateUrl: './answered-options-result.component.html',
  styleUrls: ['./answered-options-result.component.css']
})
export class AnsweredOptionsResultComponent implements OnInit {

  @Input() testId!: number;
  @Input() testResultId!: number;
  @Input() testType!: string;
  @Input() options!: AnswerOption[];
  @Input() answeredOptions!: AnsweredOption[];
  @Input() multiple = false;

  constructor() {
  }

  ngOnInit(): void {
  }

  isSelected(option: AnswerOption): boolean {
    if (this.answeredOptions) {
      return this.answeredOptions.findIndex(o => o.optionId === option.id) >= 0;
    }
    return false;
  }

}
